import { makeStyles } from '@material-ui/core'

const styles = ({ clientPortalTheme }) =>
  makeStyles((theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      minHeight: '100%',
      flexDirection: 'column',
      padding: theme.spacing(5, 2),
    },
    title: {
      textAlign: 'center',
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(28),
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(22),
      },
    },
    highlightedText: {
      color: theme.palette.grapePurple,
    },
    actionButtons: {
      display: 'flex',
      gap: theme.spacing(2),
    },
    buttonBack: {
      padding: theme.spacing(1.5, 2),
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      '&:hover': {
        borderColor: theme.palette.primary.dark,
        backgroundColor: theme.palette.action.hover,
      },
    },
    buttonPrimary: {
      padding: theme.spacing(1.5, 2),
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(15),
      backgroundColor: theme.palette.primary.main,
      color: !!clientPortalTheme
        ? theme.palette.primary.contrastText
        : theme.palette.white,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  }))

export default styles
